import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import DataType from '../../../Types/DataTablePiclist';
import { Box, Grid } from '@mui/material';
import { PhoneTwoTone } from '@mui/icons-material';
import TypSignature from '../../Tsignature';
import SearchInput from '../../SearchInput';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import SelectOption from '../../SelectOption';
import { useState } from 'react';
import axios from 'axios';
import { Crypter } from '../../../Functions/Security/Crypter';
import Data from '../../../Data/Data.json';
// const Swal = require('sweetalert2');
//import linkt = React.lazy(() => import('./questions'));
// let Link = require('../../../Data/Data.json');


//ancien compte
let searchPays: ParamsPicklist = { CodeAgence: 'PAYS', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchActivite: ParamsPicklist = { CodeAgence: 'ACTIVITE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchClassRisque: ParamsPicklist = { CodeAgence: 'CLASSERISQUE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchNiveauInstruction: ParamsPicklist = { CodeAgence: 'UNITEINSTITUTIONNELLE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchEthnie: ParamsPicklist = { CodeAgence: 'ETHNIE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchCateGo: ParamsPicklist = { CodeAgence: 'CATEGOCPT', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchZoneGeo: ParamsPicklist = { CodeAgence: 'ZONEGEOGRAPHYQUE', Table: "LIB", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: 'RUBRIQ', Choix: 22 }


const Tab1 = (props: { etatG?: boolean, form?: any, Function1?: any, Function2?: any }) => {

  const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const authHeader = useAuthHeader();
  //const [CatCpte, SetCatCompte] = useState<DataSelect[]>([]);
  const [typcpte, Settypcpte] = useState('Z');


  //Initialisation des parametres de recherche
  let searchCategocpt: ParamsPicklist = { CodeAgence: "CATEGOCPT", Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
  // let searchNumCompte: ParamsPicklist = { CodeAgence: user.codage ,Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT",Colagence: "AGCCPT",Choix: 22 }
  let searchNumCompte: ParamsPicklist = { CodeAgence: "", Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "", Choix: 22 }
  //let searchTypeCompte: ParamsPicklist = { CodeAgence: typcpte, Table: "TYPECPT", Colonne1: "CODTYP", Colonne2: "LIBELLE", Colagence: "CATEGO", Choix: 22 }
  let searchTypeCompte: ParamsPicklist = { CodeAgence: 'TYPCPT', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
  let searchDevise: ParamsPicklist = { CodeAgence: "DEVISE", Table: "lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
  let searchAgence: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "101", Choix: 22 }
  // let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "101",colfiltre:"CODAGE",valfiltre:user.codage,Choix: 22 }
  let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "", Choix: 22 }
  let searchComptegroupe: ParamsPicklist = { CodeAgence: "", Table: "", Colonne1: "idplan", Colonne2: "LIBELL", Colagence: "101", Choix: 22 }
  let searchTypesignature: ParamsPicklist = { CodeAgence: "", Table: "TYPESIGN", Colonne1: "CODETYP", Colonne2: "LIBELLE", Colagence: "101", Choix: 22 }
  let searchPlanComptable: ParamsPicklist = { CodeAgence: "I", Table: "V_PLANCP_OP", Colonne1: "idplan", Colonne2: "LIBELL", Choix: 22 }
  let searchGestionnaire: ParamsPicklist = { CodeAgence: 'GESTIONNAIRE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }

  const handleChangeCatego = (value: string) => {
    Settypcpte(value);
    props.form.setFieldValue("IDPLAN", '');
    props.form.setFieldValue("lib_IDPLAN", '');
    props.form.setFieldValue("TYPCPT", '');
    props.form.setFieldValue("lib_TYPCPT", '');
    //
  };


  const handlegetplancpt = async () => {
    //
    let Plan = props.form.getFieldValue("IDPLAN");

    let data = { CodeAgence: user.codage, Table: "comptesregroup", Colonne1: "IDPLAN", Colonne2: "CPTREGPT", Colagence: "CODAGE", Init: Plan, choix: 22 }

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(data))
      }
    };

    await
      axios(config)
        .then((response) => {

          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
              if (datas.length === 0) {
                //console.log("aucun élément");
              }
              else {
                props.form.setFieldValue("CPTREGPT", datas.CPTREGPT);

              }
            }

          }

        }).catch((error) => {
          console.log(error)

        })
  };


  //information du client
  let informationclient = {
    searchNumeroCompte: {
      Titre: "Recherche Numéro de Compte",
      label: "Numéro compte",
      name: "NUMCPT", params: searchNumCompte
    },
    searchTypeCompte: {
      Titre: "Recherche Type de Compte",
      label: "Type compte",
      name: "TYPCPT", params: searchTypeCompte
    },
    searchDevise: {
      Titre: "Recherche Dévise",
      label: "Devise",
      name: "CDDEVS", params: searchDevise
    },
    searchAgence: {
      Titre: "Recherche Agence",
      label: "Agence",
      name: "AGCCPT", params: searchAgence
    },
    SearchClient: {
      Titre: " Recherche Indice Client",
      label: "Indice client",
      name: "NUMCLI", params: searchClient
    },
    Inputcle: {
      label: "Cle",
      name: "CLECLI"
    },
    searchPlanComptable: {
      Titre: "Recherche Plan Comptable",
      label: "Plan comptable",
      name: "IDPLAN", params: searchPlanComptable
    },
    searchCompteg: {
      Titre: "Recherche Compte de Groupe",
      label: "Compte GL",
      name: "CPTREGPT", params: searchComptegroupe
    },
    //--audit
    InputNom: {
      label: "Nom Compte",
      name: "NOMCPT"
    },
    InputTelCpt: {
      label: "Telephone mobile",
      name: "TelMobil"
    },
    searchTypesignature: {
      Titre: "Recherche Type Signature",
      label: "Type de signature",
      name: "typSignature", params: searchTypesignature
    },
    //--audit
    SearchGestionnaire: {
      Titre: "Recherche Gestionnaire",
      label: "Gestionnaire",
      name: "CDGESTCLI", params: searchGestionnaire
    },
    SearchNationnalite: {
      Titre: "Recherche Nationnalité",
      label: "Nationnalité",
      name: "CDPAYS", params: searchPays
    },
    SearchActivite: {
      Titre: "Recherche Activité ",
      label: "Activité ",
      name: "CDENAE", params: searchActivite
    },
    SearchClaris: {
      Titre: "Recherche Classification Risque",
      label: "Classification risque",
      name: "CLARIS", params: searchClassRisque
    },
    SearchNiveauInstruction: {
      Titre: "Recherche Niveau Instruction",
      label: "Niveau institutionnel",
      name: "INSTRU", params: searchNiveauInstruction
    },
    SearchEthnie: {
      Titre: t("FormClientPhysique.informationclient.SearchEthnie.Titre"),
      label: t("FormClientPhysique.informationclient.SearchEthnie.label"),
      name: "ETHNIE", params: searchEthnie
    },
    SearchActiviteEconomique: {
      Titre: "Recherche Activité économique",
      label: "Activité Economique",
      name: "CDENAE", params: searchActivite
    },
    SearchCatego: {
      Titre: t("FormClientPhysique.informationclient.SearchCatego.Titre"),
      label: t("FormClientPhysique.informationclient.SearchCatego.label"),
      name: "CATPROCLI", params: searchCateGo
    },
    SearchZoneGeo: {
      Titre: "Recherche Zone Geographique",
      label: "Zone géographique",
      name: "RESIDECLI", params: searchZoneGeo
    }
  }


  return (
    <div className='tabItem' >
      <div >
        <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
          {/* <legend>Parametres Comptes </legend> */}

          <Box className='bordure1' >
            <legend style={{ marginTop: 0, marginBottom: 0, borderRadius: 8, width: '100%' }}>Informations compte</legend>
            <Grid container spacing={0}>
              <Grid item xs={12} md={6}>
                <SearInputM width={5} defaultCode={user.codage} disabled={true} defaultLibelle={user.agence} Titre={informationclient.searchAgence.Titre} label={informationclient.searchAgence.label} name={informationclient.searchAgence.name} Parametre={informationclient.searchAgence.params} form={props.form} />
                <SearInputM width={5} Titre={informationclient.SearchClient.Titre} label={informationclient.SearchClient.label} name={informationclient.SearchClient.name} Parametre={informationclient.SearchClient.params} form={props.form} ExecuteafterSelect1={props.Function1} ExecuteafterSelect2={props.Function2} />
                <SearInputM width={5} Titre={informationclient.searchPlanComptable.Titre} handleFunction={handlegetplancpt} label={informationclient.searchPlanComptable.label} name={informationclient.searchPlanComptable.name} Parametre={informationclient.searchPlanComptable.params} form={props.form} />

              </Grid>
              <Grid item xs={12} md={6}>
                <SearInputM width={5} defaultCode="XAF" disabled={true} defaultLibelle="FRANC CFA BEAC" Titre={informationclient.searchDevise.Titre} label={informationclient.searchDevise.label} name={informationclient.searchDevise.name} Parametre={informationclient.searchDevise.params} form={props.form} />
                <InputForm width={5} label={informationclient.InputNom.label} name={informationclient.InputNom.name} type='text' error='ce Champ est obligatoire' />
                <InputForm icon={<PhoneTwoTone />} width={5} label={informationclient.InputTelCpt.label} name={informationclient.InputTelCpt.name} type='number' RegExp={/[0-9]{9}$/gmi} MessExp='le numéro doit étre de 9 chiffres' error='' />
              </Grid>
            </Grid>
            <Box>
              <SearchInput width={3} dissabledCode={props.etatG} notRequired Titre={informationclient.searchNumeroCompte.Titre} label={informationclient.searchNumeroCompte.label} name={informationclient.searchNumeroCompte.name} Parametre={informationclient.searchNumeroCompte.params} form={props.form} />
            </Box>
            <Box fontStyle="inherit" className='bordure1'   >
              <TypSignature width={3} widthCode={'150%'} />
            </Box>

            <Box className='bordure1' >
              <legend style={{ marginBottom: 0, marginTop: 0, borderRadius: 8, width: '100%' }}>Informations client</legend>
              <Grid container spacing={0}>
                <Grid item xs={12} md={6}>
                  <SearInputM notRequired disabled width={5} Titre={informationclient.SearchGestionnaire.Titre} label={informationclient.SearchGestionnaire.label} name={informationclient.SearchGestionnaire.name} Parametre={informationclient.SearchGestionnaire.params} form={props.form} />
                  <SearInputM notRequired disabled width={5} Titre={informationclient.SearchNationnalite.Titre} label={informationclient.SearchNationnalite.label} name={informationclient.SearchNationnalite.name} Parametre={informationclient.SearchNationnalite.params} form={props.form} />
                  <SearInputM notRequired disabled width={5} Titre={informationclient.SearchActivite.Titre} label={informationclient.SearchActivite.label} name={informationclient.SearchActivite.name} Parametre={informationclient.SearchActivite.params} form={props.form} />
                  <SearInputM disabled notRequired width={5} Titre={informationclient.SearchClaris.Titre} label={informationclient.SearchClaris.label} name={informationclient.SearchClaris.name} Parametre={informationclient.SearchClaris.params} form={props.form} />
                  <SearInputM disabled notRequired width={5} Titre={informationclient.SearchZoneGeo.Titre} label={informationclient.SearchZoneGeo.label} name={informationclient.SearchZoneGeo.name} Parametre={informationclient.SearchZoneGeo.params} form={props.form} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SearInputM notRequired disabled width={5} Titre={informationclient.SearchNiveauInstruction.Titre} label={informationclient.SearchNiveauInstruction.label} name={informationclient.SearchNiveauInstruction.name} Parametre={informationclient.SearchNiveauInstruction.params} form={props.form} />
                  <SearInputM notRequired disabled width={5} Titre={informationclient.SearchEthnie.Titre} label={informationclient.SearchEthnie.label} name={informationclient.SearchEthnie.name} Parametre={informationclient.SearchEthnie.params} form={props.form} />
                  <SearInputM notRequired disabled width={5} Titre={informationclient.SearchActiviteEconomique.Titre} label={informationclient.SearchActiviteEconomique.label} name={informationclient.SearchActiviteEconomique.name} Parametre={informationclient.SearchActiviteEconomique.params} form={props.form} />
                  <SearInputM notRequired disabled width={5} Titre={informationclient.SearchCatego.Titre} label={informationclient.SearchCatego.label} name={informationclient.SearchCatego.name} Parametre={informationclient.SearchCatego.params} form={props.form} />
                </Grid>
              </Grid>
            </Box>
          </Box>

        </Box>
      </div>
    </div>
  );
}

export default Tab1;